//TODO maybe not needed
export function createSelectedVariant(variant) {
	const selectedVariant = variant && typeof variant === "object" ? variant : {};
	return {
		gene: selectedVariant.gene,
		rs: selectedVariant.rs,
		hgvs_c: selectedVariant.hgvs_c,
		hgvs_p: selectedVariant.hgvs_p,
		hgvs_m: selectedVariant.hgvs_m,
		transcript: selectedVariant.transcript,
		genomic_coord: selectedVariant.genomic_coord,
	};
}

export function createSelectedVariantSearchMessage(variant) {
	const text = createSelectedVariant(variant);
	const hasVariantDetails = [
		text.rs,
		text.hgvs_c,
		text.hgvs_p,
		text.hgvs_m,
		text.transcript,
		text.genomic_coord,
	].some(Boolean);

	if (text.gene && !hasVariantDetails) {
		return `Searching for gene ${text.gene}`;
	}

	const normalizedDetails = [
		text.rs,
		text.hgvs_c,
		text.hgvs_p,
	].filter(Boolean);
	const fallbackDetails = [text.genomic_coord, text.hgvs_m].filter(Boolean);
	const variantDetails =
		normalizedDetails.length > 0
			? normalizedDetails
			: fallbackDetails.length > 0
				? fallbackDetails
				: [variant?.input].filter(Boolean);

	return (
		`Searching for variant ${variantDetails.join(", ")}` +
		(text.transcript ? ` on transcript ${text.transcript}` : "") +
		(text.gene ? ` on gene ${text.gene}` : "")
	);
}

export function createSelectedVariantLabel(variant, separator = " ") {
	const normalizedDetails = [
		variant.gene,
		variant.transcript,
		variant.hgvs_c,
		variant.hgvs_p,
		variant.rs
	].filter(Boolean);
	const variantDetails =
		normalizedDetails.length > 0
			? normalizedDetails
			: [variant?.input].filter(Boolean);

	return [...variantDetails]
		.filter(Boolean)
		.join(separator);
}
